// AUTO-GENERATED at build time by scripts/generate-build-version.js — do not edit by hand.
export const BUILD_SUBVERSION = 4102;
export const BUILD_NUMBER = 19727;
